export const errMsg = {
  reqSelName: "กรุณากรอกชื่อ-นามสกุล/ชื่อบริษัท",
  reqTaxId: "กรุณากรอกเลขประจำตัวผู้เสียภาษี",
  reqSelTaxId: "เลขประจำตัวผู้เสียภาษีไม่ถูกต้อง",
  reqsellerBranch: "กรุณากรอกลำดับเลขที่สาขา",
  reqHouseNo: "กรุณากรอกบ้านเลขที่",
  reqPostcode: "กรุณากรอกรหัสไปรษณีย์",
  notPostcode: "รหัสไปรษณีย์ไม่มีในระบบ",
  reqProv: "กรุณาเลือกจังหวัด",
  notProv: "จังหวัดไม่ถูกต้อง",
  reqDistrict: "กรุณาเลือกอำเภอ",
  reqSubDistrict: "กรุณาเลือกตำบล",
  saveSelData: "บันทึกข้อมูลไม่สำเร็จ",
  seller_branch_name: "กรุณากรอก Branch Name",
  bu: "กรุณากรอก BuCode",
  seller_storeid: "กรุณากรอก Store ID",
  seller_branch_id: "กรุณากรอก Branch ID",
  branch: "กรุณากรอก Branch Code ",
  house_no: "กรุณากรอกบ้านเลขที่",
  postcode: "กรุณากรอกรหัสไปรษณีย์",
  district: "กรุณาเลือกอำเภอ",
  sub_district: "กรุณาเลือกตำบล",
  province: "กรุณาเลือกจังหวัด",
  phone1: "กรุณากรอก รหัสจังหวัด ให้ครบถ้วน",
  phone2: "กรุณากรอก เบอร์โทรศัพท์ ให้ครบถ้วน",
  error: "ไม่สามารถเชื่อมต่อได้ กรุณาลองใหม่อีกครั้ง",
  source_system: "กรุณากรอก Source system ให้ครบถ้วน",
};
export const sccMsg = {
  updateScc: "บันทึกข้อมูลสำเร็จ",
};
